<template>
    <multiselect
        data-test-id="advertiser-dropdown"
        v-model="selection"
        :options="advertisersList"
        :multiple="false"
        track-by="id"
        label="label"
        :placeholder="placeholder"
        :close-on-select="true"
        :searchable="true"
        :disabled="disabled"
        @input="inputValue($event)"
    >
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import isEmpty from 'lodash/isEmpty'

    export default {
        name: 'AdvertiserSwitcher',

        props: ['advertiserId'],

        data() {
            return {
                selection:   null,
                advertisers: []
            }
        },

        computed: {
            advertisersList() {
                return this.advertisers.map(item => {
                    return {
                        ...item,
                        label: `${item.name} (${item.id})`
                    }
                })
            },
            placeholder() {
                return isEmpty(this.advertisers) ? 'Loading advertisers...' : 'Select Advertiser'
            },
            disabled() {
                return isEmpty(this.advertisers)
            }
        },

        methods: {
            inputValue(advertiser) {
                if (isEmpty(advertiser)) {
                    return
                }

                $.loading.show()
                axios.get(window.Portal.baseUrl + '/api/advertiser/' + advertiser.id + '/switch')
                    .then((response) => {
                        window.location = response.data.redirect_to
                    })
            },

            fetchAdvertisers() {
                axios.get(window.Portal.baseUrl + '/api/admin/advertiser/')
                    .then((response) => {
                        this.advertisers = response.data.advertisers

                        if (Number(this.advertiserId) > 0) {
                            const advertisersSelected = this.advertisers.filter(advertiser => Number(advertiser.id) === Number(this.advertiserId))
                            if (advertisersSelected.length > 0) {
                                const advertiserSelected = advertisersSelected[0]
                                advertiserSelected.label = `${advertiserSelected.name} (${advertiserSelected.id})`
                                this.selection = advertiserSelected
                            }
                        }
                    })
            }
        },

        mounted() {
            this.fetchAdvertisers()
        },

        components: {
            Multiselect
        }
    }
</script>
